import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import {
  replaceQueryWithSelected as replaceQueryWithSelectedHelper,
  calculateSelectedStartEnd as calculateSelectedStartEndHelper,
} from '@Components/AutosuggestInput/AutosuggestInputHelper';

const withAurosuggestOnSelectHOCGenerator = (Component) => {
  function WithAutosuggestOnSelectHOC(props) {
    const { onSelect, onSelectPreProcessor, query, value, matches, closeDropdownAndResetMatches, setValue } = props;

    const autosuggestOnSelect = useCallback(
      (index) => {
        const match = matches[index];
        const replacedValue = replaceQueryWithSelectedHelper({
          string: value,
          query,
          selected: onSelectPreProcessor(match.title),
        });

        const { start, end } = calculateSelectedStartEndHelper({
          string: replacedValue,
          selected: match.title,
        });

        closeDropdownAndResetMatches();
        setValue(replacedValue);

        // call owner props.onSelect with match and metadata, mostly for analytics
        onSelect(match, {
          index,
          query,
          totalMatches: matches.length,
          // eslint-disable-next-line custom/no-unsafe-deep-access
          hasExactMatch: map(matches, 'title').includes(query),
          start,
          end,
        });
      },
      [matches, query, value]
    );

    return <Component {...props} autosuggestOnSelect={autosuggestOnSelect} />;
  }

  WithAutosuggestOnSelectHOC.propTypes = {
    onSelect: PropTypes.func,
    onSelectPreProcessor: PropTypes.func,
    query: PropTypes.string,
    value: PropTypes.string,
    matches: PropTypes.arrayOf(PropTypes.shape({ title: PropTypes.string })),
    closeDropdownAndResetMatches: PropTypes.func,
    setValue: PropTypes.func,
  };

  return WithAutosuggestOnSelectHOC;
};

const withAutosuggestOnSelect = () => (Component) => withAurosuggestOnSelectHOCGenerator(Component);

export default withAutosuggestOnSelect;
